import { render, staticRenderFns } from "./mth.vue?vue&type=template&id=2b247354&scoped=true"
import script from "./mth.vue?vue&type=script&lang=js"
export * from "./mth.vue?vue&type=script&lang=js"
import style0 from "./mth.vue?vue&type=style&index=0&id=2b247354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b247354",
  null
  
)

export default component.exports